import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useBorrowerContext } from "../../../../../../store/borrower-details";
import { toast } from "react-toastify";
import styles from "../../../../../../BorrowerDetails.module.css";
import CloseIcon from "@mui/icons-material/Close";
import Pdf from "../../../../../../../../../assets/PDF_file_icon 4.svg";
import excelIcon from "../../../../../../../../../assets/icons8-excel.svg";
import { url } from "../../../../../../../../../App";

const MilkIncomeSelectionModal = ({
  modalStatus,
  closeModal,
  isBorrower,
  coapplicant_id,
  loan_id,
  statusChange,
}) => {
  const { borrowerData, contextMenuHandler } = useBorrowerContext();
  const [docsArray, setDocsArray] = useState([]);
  const [selectedDocs, setSelectedDocs] = useState([]);
  // const fetchLoanDetails = borrowerData.loan;
  const EMAIL = Cookies.get("Email");
  const TOKEN = Cookies.get("Token");

  useEffect(() => {
    const fetchDocs = async () => {
      try {
        console.log(isBorrower, borrowerData.loan);
        if (isBorrower === "true" || isBorrower === true) {
          const docName = "loan_milkstatement";
          const matchedLoan = borrowerData.loan.find(
            (item) => String(item.loan_id) === String(loan_id)
          );
          const array = matchedLoan?.[docName] || [];

          if (!array.length) return;
          
          const docs = await Promise.all(
            array.map(async (data) => {
              const req = {
                loan_id: loan_id,
                borrower_uniqueno: localStorage.getItem("uniqueID"),
                doc_name: data?.doc_name ?? "",
                doc_type: data?.doc_type,
                token: TOKEN,
                email: EMAIL,
              };
              console.log("Borrower Request Payload:", req);

              const res = await axios.post(`${url}/loan/viewdoc`, req);
              
              return {
                doc: res.data?.doc_base64,
                docType: data?.doc_type,
                location: data?.location,
                doc_name: data?.doc_name ?? "",
              };
            })
          );

          setDocsArray(docs);
        } else {
          const docName = "coapplicant_milkstatement";
          const matchedCoapplicant = borrowerData?.coapplicant?.find(
            (c) => c.coapplicant_id === coapplicant_id
          );
          const array = matchedCoapplicant?.[docName] || [];
          console.log(array);
          if (!array.length) return;

          const docs = await Promise.all(
            array.map(async (data) => {
              console.log(coapplicant_id);
              const req = {
                token: TOKEN,
                email: EMAIL,
                coapplicant_id: coapplicant_id,
                doc_name: data?.doc_name ?? "",
                doc_type: data?.doc_type,
                coapplicant_borrower_uniqueno: localStorage.getItem("uniqueID"),
              };
              console.log("Co-applicant Request Payload:", req);

              const res = await axios.post(`${url}/coapplicant/viewdoc`, req);

              if (!res.data.auth) {
                toast.error(res.data.message);
                return null;
              }

              return {
                doc: res.data?.doc_base64,
                docType: data?.doc_type,
                doc_name: data?.doc_name ?? "",
                location: data?.location,
              };
            })
          );

          setDocsArray(docs);
        }
      } catch (err) {
        console.error("Error fetching docs:", err);
        toast.error("Failed to load documents");
      }
    };

    if (modalStatus) {
      fetchDocs();
    }
  }, [modalStatus, borrowerData, isBorrower, coapplicant_id, EMAIL, TOKEN, loan_id]);

  if (!modalStatus) return null;

  const excelHandler = () => {
    toast.error("Cannot view Excel in your browser. Please download the file");
  };

  const handleCheckboxChange = (index) => {
    setSelectedDocs((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  function base64ToFile(base64String, fileName, mimeType) {
    const arr = base64String.split(",");
    const base64 = arr.length > 1 ? arr[1] : arr[0];
    const binary = atob(base64);
    const len = binary.length;
    const u8arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      u8arr[i] = binary.charCodeAt(i);
    }
    return new File([u8arr], fileName, { type: mimeType });
  }

  const handleRun = async () => {
    if (!selectedDocs || selectedDocs.length === 0) {
      toast.warning("Please select at least one document before running.");
      return;
    }

    try {
      const formData = new FormData();

      selectedDocs.forEach((index) => {
        const doc = docsArray[index];

        let mimeType = "";
        switch (doc?.docType) {
          case "pdf":
            mimeType = "application/pdf";
            break;
          case "xlsx":
            mimeType =
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            break;
          default:
            mimeType = `image/${doc?.docType}`;
        }

        const fileName = doc.doc_name
          ? `${doc.doc_name}.${doc?.docType}`
          : `document_${index}.${doc?.docType}`;

        const file = base64ToFile(doc.doc, fileName, mimeType);

        console.log("📄 Converted File:", file);
        console.log("name:", file.name, "size:", file.size, "type:", file.type);

        formData.append("docs", file);
      });
      //   for (let [key, value] of formData.entries()) {
      //     if (value instanceof File) {
      //       console.log(
      //         `${key}: File name=${value.name}, size=${value.size}, type=${value.type}`
      //       );
      //     } else {
      //       console.log(`${key}: ${value}`);
      //     }
      //   }

      formData.append("prompt_doc", "milk_statement");
      formData.append("loan_id", loan_id);
      formData.append("is_borrower", isBorrower);
      formData.append("coapplicant_id", coapplicant_id);

      toast.success(
        "AI is analyzing your milk statement(s). Please revisit this section after about 1 minute."
      );
      statusChange("Processing");

      setTimeout(() => {
        closeModal();
        setSelectedDocs([]);
      }, 5000);

      const res = await axios.post(`${url}/ai/doc-summary`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          token: TOKEN,
          email: EMAIL,
        },
      });

      console.log("API Response:", res.data);
      statusChange("Completed");
      // toast.success("AI is analyzing your milk statement(s). Please revisit this section after about 1 minute.");

      // setTimeout(() => {
      //   closeModal();
      // }, 5000);
      // window.location.reload();
    } catch (error) {
      console.error("Error calling API:", error);
      toast.error("Something went wrong while running.");
      setTimeout(() => {
        closeModal();
        setSelectedDocs([]);
      }, 5000);
      statusChange("Failed");
    }
  };

  return (
    <div className={styles.borrowerDocumentsModal}>
      <div className={styles.borrowerDocumentsModaOverlay}>
        <div className={styles.borrowerDocumentsModalContent}>
          <h3>Milk Statement</h3>

          <div className={styles.multiDoc}>
            {docsArray.map((data, index) => {
              console.log("Final Doc Data:", data);

              return data?.docType !== "pdf" ? (
                <div key={index}>
                  <section>
                    {data?.docType !== "xlsx" ? (
                      <img
                        onContextMenu={contextMenuHandler}
                        draggable={false}
                        src={`data:image/${data?.docType};base64,${data.doc}`}
                        alt=""
                        className={styles.docsImg}
                      />
                    ) : (
                      <img
                        src={excelIcon}
                        alt=""
                        className={styles.docsPDF}
                        onClick={excelHandler}
                      />
                    )}
                  </section>
                  <div className={styles.checkboxContainer}>
                    <input
                      type="checkbox"
                      id={`checkbox-${index}`}
                      checked={selectedDocs.includes(index)}
                      onChange={() => handleCheckboxChange(index)}
                    />
                    <label htmlFor={`checkbox-${index}`}>
                      {data.doc_name || "Select"}
                    </label>
                  </div>
                </div>
              ) : (
                <div key={index}>
                  <section>
                    <img src={Pdf} alt="" className={styles.docsPDF} />
                  </section>
                  <div className={styles.checkboxContainer}>
                    <input
                      type="checkbox"
                      id={`checkbox-${index}`}
                      checked={selectedDocs.includes(index)}
                      onChange={() => handleCheckboxChange(index)}
                    />
                    <label htmlFor={`checkbox-${index}`}>
                      {data.doc_name || "Select"}
                    </label>
                  </div>
                </div>
              );
            })}
          </div>

          <button
            className="analyse-btn"
            onClick={handleRun}
            disabled={selectedDocs.length === 0}
          >
            Run
          </button>
          <CloseIcon className={styles.CloseIcon} onClick={closeModal} />
        </div>
      </div>
    </div>
  );
};

export default MilkIncomeSelectionModal;
